export default __webpack_public_path__ + "1609efe3f9c356e9a8ee24d8cbed0a36.wav";